import React from 'react';
import { motion } from 'framer-motion';
import { Apple, Heart, Baby, AlertTriangle } from 'lucide-react';
import { AGE_RANGES } from '../../../utils/baby/ageRanges';

interface AgeRangeSelectorProps {
  selectedAge: string;
  onAgeSelect: (age: string) => void;
}

const getAgeIcon = (ageId: string, isSelected: boolean) => {
  const iconProps = { size: 20, className: isSelected ? 'text-white' : 'text-pink-500' };
  switch (ageId) {
    case '4-6': return <Apple {...iconProps} />;
    case '6-8': return <Heart {...iconProps} />;
    case '8-12': return <Baby {...iconProps} />;
    case '12+': return <AlertTriangle {...iconProps} />;
    default: return <Baby {...iconProps} />;
  }
};

export const AgeRangeSelector: React.FC<AgeRangeSelectorProps> = ({
  selectedAge,
  onAgeSelect
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {Object.entries(AGE_RANGES).map(([id, range]) => (
        <motion.button
          key={id}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={() => onAgeSelect(id)}
          className={`p-4 rounded-lg text-left transition-all ${
            selectedAge === id
              ? 'bg-pink-500 text-white shadow-lg'
              : 'bg-white hover:bg-pink-50'
          }`}
        >
          <div className="flex items-center gap-2 mb-2">
            {getAgeIcon(id, selectedAge === id)}
            <h3 className="font-semibold">{range.label}</h3>
          </div>
          <p className={`text-sm ${selectedAge === id ? 'text-white/90' : 'text-gray-600'}`}>
            {range.description}
          </p>
        </motion.button>
      ))}
    </div>
  );
};